<template>
  <div>
    <iframe :src="qosUrl" class="frameClass" hight='auto' id="frameqos" frameborder="no"></iframe>
  </div>
</template>
<script>
  export default{
    mounted(){
      const oIframe = document.getElementById('frameqos');
      const deviceHeight = document.documentElement.clientHeight;
      oIframe.style.height = (Number(deviceHeight) - 105) + 'px';
    },
  }
</script>
<style scoped>
  .frameClass{
    width: 100%;
  }
</style>
